import { ReactNode, useCallback } from "react";
import { GridColumn as Column } from "@progress/kendo-react-grid/dist/npm/GridColumn";
import { GridCellProps } from "@progress/kendo-react-grid";
import CommandCell from "./CommandCell";
import { KendoReactColoredFooterCell } from "../../Layout/Grid/Cell/KendoReactColoredFooterCell";

interface Props<T> {
  readonly commands?: (dataItem: T) => ReactNode[];
  showFooterCell?: boolean;
}

export default function CommandColumn<T>({ commands, showFooterCell = false }: Props<T>) {
  const CommandCellMemorized = useCallback(
    (props: GridCellProps) => <CommandCell dataItem={props.dataItem} commands={commands} />,
    [commands]
  );

  const kendoReactColoredFooterCell = () => {
    return showFooterCell ? <KendoReactColoredFooterCell /> : null;
  };

  return (
    <Column
      key="ControlColumn"
      field="ControlColumn"
      title=" "
      filter="text"
      editable={false}
      filterable={false}
      sortable={false}
      cell={CommandCellMemorized}
      width="60px"
      footerCell={() => kendoReactColoredFooterCell()}
    />
  );
}
